module.exports = __webpack_public_path__ + "static/img/logo2.078f57e0.png";